import * as Yup from "yup";

import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";

import {
  createSailor,
  fetchNaytikosInfoFromGateWay,
} from "../../../services/sailorService";
import dayjs from "dayjs";
import { fetchDiplomaKinds } from "../../../services/diplomaKindService";
import useLocale from "../../../hooks/useLocale";
import styled from "styled-components/macro";
import GovGrButton from "../../../components/GovGrButton";
import GovGrTextField from "../../../components/GovGrTextField";
import {
  FIELD_IS_REQUIRED,
  FIELD_MUST_BE_ONLY_NUMBERS,
} from "../../../constants";
import GovGrSelectBox from "../../../components/GovGrSelectBox";
import GovGrDate from "../../../components/GovGrDate";
import GovGrModal from "../../../components/GovGrModal";

function CreateDialog({ open, close, refetch }) {
  const { t } = useLocale();
  const [error, setError] = useState("");
  const [dataFromNaytikosGateway, setDataFromNaytikosGateWay] = useState({});
  const [initialValues, setInitialValues] = useState({});

  // Mutation for creating data
  const { mutate } = useMutation(createSailor, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const { mutate: mutateSearchNautikos } = useMutation(
    fetchNaytikosInfoFromGateWay,
    {
      onSuccess: (data) => {
        setDataFromNaytikosGateWay(data);
      },
      onError: (error) => {
        switch (error) {
          default: {
            setError(t("A network error occured. Please try again later"));
          }
        }
      },
    }
  );
  const { data: diplomaKinds } = useQuery("diplomaKinds", fetchDiplomaKinds);

  useEffect(() => {
    setInitialValues({
      ameth: "",
      first_name: dataFromNaytikosGateway?.first_name || "",
      last_name: dataFromNaytikosGateway?.last_name || "",
      f_name: dataFromNaytikosGateway?.f_name || "",
      m_name: dataFromNaytikosGateway?.m_name || "",
      ani: "",
      birth_date: new Date(dataFromNaytikosGateway?.birth_date),
      // birth_date: new Date(),

      diploma: null,
    });
  }, [dataFromNaytikosGateway]);

  const sailorFormValidation = Yup.object().shape({
    ameth: Yup.string().required(t("Field is required")),
    first_name: Yup.string().required(t("Field is required")),
    last_name: Yup.string().required(t("Field is required")),
    f_name: Yup.string().required(t("Field is required")),
    m_name: Yup.string().required(t("Field is required")),
    ani: Yup.string()
      .required(t("Field is required"))
      .min(8, t("Ani number must be at least 8 characters")),
    birth_date: Yup.date().nullable().required(t("Field is required")),
    diploma: Yup.object({
      id: Yup.string().required(t("Field is required")).nullable(),
    })
      .typeError(t("Field is required"))
      .required(t("Field is required")),
  });

  const handleCreateItem = (values) => {
    mutate({ items: JSON.stringify([values]) });
  };

  const searchNautikos = (values) => {
    mutateSearchNautikos({ id: parseInt(values.naytikosAminaId) });
  };

  return (
    <>
      <GovGrModal open={open} onClose={close} customContent={true}>
        <div className="govgr-heading-l m-0">
          {t("Insert New Sailor Details")}
        </div>
        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />
        <StyledBox>
          <StyledTypography variant="h3">
            {t("Search Sailor if already exists by Amina")}
          </StyledTypography>
          <Formik
            initialValues={{ naytikosAminaId: "" }}
            validationSchema={Yup.object().shape({
              naytikosAminaId: Yup.number()
                .typeError(t(FIELD_MUST_BE_ONLY_NUMBERS))
                .required(t(FIELD_IS_REQUIRED)),
            })}
            onSubmit={(values, { setSubmitting }) => {
              searchNautikos(values);
              setSubmitting(false);
            }}
          >
            {({ submitForm, values }) => (
              <StyledForm>
                <GovGrTextField
                  name="naytikosAminaId"
                  style={{ margin: "0 1rem 1rem 0" }}
                  nohint="true"
                />
                <GovGrButton buttonText={t("Search")} onClick={submitForm} />
              </StyledForm>
            )}
          </Formik>
        </StyledBox>
        <Formik
          initialValues={initialValues}
          validationSchema={sailorFormValidation}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            const { birth_date, diploma, ...rest } = values;

            const createData = {
              ...rest,
              diploma_id: diploma.id,
              birth_date: dayjs(birth_date).format("YYYY-MM-DD"),
            };

            handleCreateItem(createData);
            setSubmitting(false);
          }}
        >
          {({ submitForm, touched, errors }) => (
            <Form>
              <DialogContent>
                <Grid container direction="column">
                  <GovGrTextField label={t("Ameth")} name="ameth" />

                  <Grid container direction="row" spacing={4}>
                    <Grid item xs={6}>
                      <GovGrTextField
                        name="first_name"
                        label={t("First Name")}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <GovGrTextField name="last_name" label={t("Last Name")} />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={4}>
                    <Grid item xs={6}>
                      <GovGrTextField name="f_name" label={t("Father Name")} />
                    </Grid>
                    <Grid item xs={6}>
                      <GovGrTextField label={t("Mother Name")} name="m_name" />
                    </Grid>
                  </Grid>

                  <GovGrDate
                    required
                    name="birth_date"
                    label={t("Birth Date")}
                  />
                  <GovGrTextField name="ani" label={t("ANI")} />
                  <GovGrSelectBox
                    name="diploma"
                    label={t("Diploma Kind")}
                    options={diplomaKinds || []}
                    optionlabel="name"
                    defaultoptiontext={t("Choose Here")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              </DialogContent>
              <DialogActions>
                <GovGrButton
                  onClick={submitForm}
                  color="primary"
                  buttonText={t("Submit")}
                />
                <GovGrButton
                  onClick={close}
                  variant="secondary"
                  buttonText={t("Cancel")}
                />
              </DialogActions>
            </Form>
          )}
        </Formik>
      </GovGrModal>
    </>
  );
}
const StyledTypography = styled(Typography)`
  margin-left: 2.5rem;
`;

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const StyledForm = styled(Form)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export default CreateDialog;
